import FormControl from "@mui/material/FormControl";
import { Button, Drawer, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useState, SyntheticEvent } from "react";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { BASE_URL } from "../services/client/rest";
import Snackbar from "@material-ui/core/Snackbar";
import MySnackbarContentWrapper from "../MySnackbarContentWrapper";

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },
  date1: { border: "1px solid red" },
}));

function AddContact({
  open,
  onClose,
  serialNumber,
  RefreshDealerContacts,
}: {
  open: boolean;
  onClose: any;
  serialNumber: number;
  RefreshDealerContacts: any;
}) {
  const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
  const [currentRow, SetCurrentRow] = useState([] as any);
  const [openSnackBar, setOpen] = React.useState(false);
  const [result, SetResult] = useState("" as string);

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  var bearer = "Bearer " + localStorage.getItem("token");
  const headers = {
    Authorization: bearer,
  };

  function OnSaveClick() {
    const request = {
      customerSerialNumber: serialNumber,
      name: currentRow.customerName,
      email: currentRow.customerEmail,
      phone: currentRow.customerPhone,
    };
    let url = BASE_URL + "Customer/CustomerContact";

    axios
      .post(url, request, {
        headers,
      })
      .then((response) => {
        SetResult("success");
        setOpen(true);
        RefreshDealerContacts();
      })
      .catch((err) => {
        SetResult("failure");
        setOpen(true);
        console.log(err);
      });
  }

  React.useEffect(() => {
    SetOpenDrawer(open);
  }, [open]);

  function SetValue(key: string, value: any) {
    currentRow[key] = value;
  }

  return (
    <Box>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        {result === "success" ? (
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant="success"
            message="Contact Added Successfully."
          />
        ) : (
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant="error"
            message="Something went wrong."
          />
        )}
      </Snackbar>
      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => onClose(0)}
        variant={"temporary"}
      >
        <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
          <Box style={{ width: "100%" }}>
            <Box style={{ marginTop: "12px" }}>
              <TextField
                required
                id="outlined-required"
                label="Name"
                onChange={(e: any) => {
                  SetValue("customerName", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <TextField
                required
                id="outlined-required"
                label="Email"
                onChange={(e: any) => {
                  SetValue("customerEmail", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <TextField
                required
                id="outlined-required"
                label="Phone"
                onChange={(e: any) => {
                  SetValue("customerPhone", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ padding: "10px", border: "0px solid red" }}
            >
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={OnSaveClick}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
export default AddContact;
